import { useState, useEffect } from "react";
import { Link } from "react-router-dom";


import { DashboardLayout } from "../../Components/Layout/DashboardLayout";
import CustomTable from "../../Components/CustomTable";
import CustomModal from "../../Components/CustomModal";

import CustomPagination from "../../Components/CustomPagination"
import CustomInput from "../../Components/CustomInput";
import { formatDate } from "../../utils/dateUtils";
import { useErrorBoundary } from "../../Hooks/useErrorBoundary";

import './style.css'



export const Orders = () => {
  const { handleError } = useErrorBoundary();
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [showModal3, setShowModal3] = useState(false);
  const [showModal4, setShowModal4] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(8);
  const [inputValue, setInputValue] = useState('');


  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };



  const inActive = () => {
    setShowModal(false)
    setShowModal2(true)
  }
  const ActiveMale = () => {
    setShowModal3(false)
    setShowModal4(true)
  }

  const handleChange = (e) => {
    setInputValue(e.target.value);
  }

  const filterData = data?.filter(item =>
    item?.first_name?.toLowerCase().includes(inputValue.toLowerCase())
  );

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filterData.slice(indexOfFirstItem, indexOfLastItem);



  useEffect(() => {
    document.title = 'Virual PI | Orders';
    const LogoutData = localStorage.getItem('login');
    document.querySelector('.loaderBox').classList.remove("d-none");
    const apiUrl = process.env.REACT_APP_BASE_URL;
    fetch(`${apiUrl}/orders`,
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${LogoutData}`
        },
      }
    )

      .then(response =>
        response.json()
      )
      .then((data) => {
        document.querySelector('.loaderBox').classList.add("d-none");
        if (data?.status) {
          setData(data.data);
        }
      })
      .catch((error) => {
        document.querySelector('.loaderBox').classList.add("d-none");
        handleError(error);
      })


  }, []);

  const maleHeaders = [
    {
      key: "id",
      title: "S.No",
    },
    {
      key: "fullName",
      title: "Full Name",
    },
    {
      key: "total",
      title: "Total",
    },
    {
      key: "generatedDate",
      title: "Generated Date",
    },
    {
      key: "socialReportInclude",
      title: "Social Media Report",
      align: "center",
    },
    {
      key: "socialReportSent",
      title: "Social Media Report Sent",
      align: "center",
    },
    {
      key: "action",
      title: "Action",
    },
  ];


  return (
    <>
      <DashboardLayout>
        <div className="container-fluid">
          <div className="row mb-3">
            <div className="col-12">
              <div className="dashCard">
                <div className="row mb-3 justify-content-between">
                  <div className="col-md-6 mb-2">
                    <h2 className="mainTitle">Orders</h2>
                  </div>
                  <div className="col-md-4 mb-2">
                    <div className="addUser">
                      {/* <CustomButton text="Add User" variant='primaryButton' onClick={hanldeRoute}/> */}
                      <CustomInput type="text" placeholder="Search Here..." value={inputValue} inputClass="mainInput" onChange={handleChange} />
                    </div>
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-12">
                    <CustomTable
                      headers={maleHeaders}

                    >
                      <tbody>
                        {currentItems.map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td className="text-capitalize">
                              {item?.first_name}{' '}
                              {item?.last_name}
                            </td>
                            <td>${item?.total}</td>
                            <td>{formatDate(item?.created_at)}</td>
                            {/* <td className="text-capitalize">
                              {item?.last_name}
                            </td> */}
                            <td className="text-center"><span className={`status-badge ${item?.has_social_media_report == '1' ? 'active' : 'inactive'}`}>{item?.has_social_media_report == '1' ? '✅ Included' : '❌ Not Included'}</span></td>
                            {/* <td className={item?.status == 1 ? 'greenColor' : "redColor"}>{item?.status == 1 ? 'Active' : "Inactive"}</td> */}
                            <td className="text-center" ><span className={`status-badge ${item?.is_social_media_report_sent == '1' ? 'active' : 'inactive'}`}>{item?.has_social_media_report == '1' ? item?.is_social_media_report_sent == '1' ? '📤 Sent' : '🕗 Pending' : '❌ Not sent'}</span></td>
                            <td>
                              <Link to={`/orders/${item?.id}`} className="btn btn-dark py-1">View</Link>
                              {/* <Dropdown className="tableDropdown">
                                <Dropdown.Toggle variant="transparent" className="notButton classicToggle">
                                  <FontAwesomeIcon icon={faEllipsisV} />
                                </Dropdown.Toggle>
                                <Dropdown.Menu align="end" className="tableDropdownMenu">
                                  <Link to={`/user-detail/${item?.id}`} className="tableAction"><FontAwesomeIcon icon={faEye} className="tableActionIcon" />View</Link>
                                  <Link to={`/edit-user/${item?.id}`} className="tableAction"><FontAwesomeIcon icon={faPencil} className="tableActionIcon" />Edit</Link>
                                </Dropdown.Menu>

                              </Dropdown> */}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </CustomTable>
                    {data?.length / itemsPerPage > 1 &&
                      <CustomPagination
                        itemsPerPage={itemsPerPage}
                        totalItems={data.length}
                        currentPage={currentPage}
                        onPageChange={handlePageChange}
                      />
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>

          <CustomModal show={showModal} close={() => { setShowModal(false) }} action={inActive} heading='Are you sure you want to mark this user as inactive?' />
          <CustomModal show={showModal2} close={() => { setShowModal2(false) }} success heading='Marked as Inactive' />

          <CustomModal show={showModal3} close={() => { setShowModal3(false) }} action={ActiveMale} heading='Are you sure you want to mark this user as Active?' />
          <CustomModal show={showModal4} close={() => { setShowModal4(false) }} success heading='Marked as Active' />



        </div>
      </DashboardLayout>
    </>
  );
};
